import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=193584fe&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=ts&"
export * from "./ModalFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=193584fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193584fe",
  null
  
)

export default component.exports